import { useState, useRef, useEffect } from "react";
import { Eye, Repeat, Star } from "lucide-react";
import productimg from "../../product-01-330x440.png";
import productimg1 from "../../product-02-330x440.png";
import productimg2 from "../../product-03-330x440.png";
import Header from "../../components/VibrantSolComponents/Header";
import Footer from "../../components/VibrantSolComponents/Footer";

function Products() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Your main products data, grouped with categories
  const [products] = useState([
    // HAIR REGROWTH
    {
      name: "Super Pure",
      price: 29,
      oldPrice: 39,
      image: productimg1,
      quantity: 1,
      category: "HAIR REGROWTH",
    },
    {
      name: "Hair Tonic",
      price: 25,
      oldPrice: 35,
      image: productimg,
      quantity: 1,
      category: "HAIR REGROWTH",
    },
    {
      name: "Regrowth Activator Spray",
      price: 32,
      oldPrice: 42,
      image: productimg2,
      quantity: 1,
      category: "HAIR REGROWTH",
    },

    // SKIN CARE
    {
      name: "Natural Coconut Cleansing Oil",
      price: 29,
      oldPrice: 39,
      image: productimg,
      quantity: 1,
      category: "SKIN CARE",
    },
    {
      name: "Cleansing Balm",
      price: 29,
      oldPrice: 39,
      image: productimg2,
      quantity: 1,
      category: "SKIN CARE",
    },
    {
      name: "Soothing Face Serum",
      price: 34,
      oldPrice: 50,
      image: productimg1,
      quantity: 1,
      category: "SKIN CARE",
    },

    // MEANTAL HEALTH
    {
      name: "Stress Relief Supplement",
      price: 22,
      oldPrice: 30,
      image: productimg1,
      quantity: 1,
      category: "MEANTAL HEALTH",
    },
    {
      name: "Calming Gummies",
      price: 28,
      oldPrice: 38,
      image: productimg2,
      quantity: 1,
      category: "MEANTAL HEALTH",
    },
    {
      name: "Brain Booster Capsules",
      price: 24,
      oldPrice: 34,
      image: productimg,
      quantity: 1,
      category: "MEANTAL HEALTH",
    },

    // WEIGHT LOSS
    {
      name: "Weight Loss Capsules",
      price: 27,
      oldPrice: 37,
      image: productimg2,
      quantity: 1,
      category: "WEIGHT LOSS",
    },
    {
      name: "Metabolism Support",
      price: 29,
      oldPrice: 44,
      image: productimg1,
      quantity: 1,
      category: "WEIGHT LOSS",
    },
    {
      name: "Fat Burner Powder",
      price: 31,
      oldPrice: 45,
      image: productimg,
      quantity: 1,
      category: "WEIGHT LOSS",
    },

    // SEXUAL HEALTH
    {
      name: "Revitalizing Serum",
      price: 35,
      oldPrice: 45,
      image: productimg2,
      quantity: 1,
      category: "SEXUAL HEALTH",
    },
    {
      name: "Herbal Supplement",
      price: 33,
      oldPrice: 41,
      image: productimg1,
      quantity: 1,
      category: "SEXUAL HEALTH",
    },
    {
      name: "Intimate Gel",
      price: 30,
      oldPrice: 39,
      image: productimg,
      quantity: 1,
      category: "SEXUAL HEALTH",
    },
  ]);

  // List of all possible categories
  const categories = [
    "HAIR REGROWTH",
    "SKIN CARE",
    "SEXUAL HEALTH",
    "WEIGHT LOSS",
    "MEANTAL HEALTH",
  ];

  // State for currently selected category, default to first
  const [selectedCategory, setSelectedCategory] = useState("HAIR REGROWTH");

  // Filter products by category, showing only up to 3 items
  const filteredProducts = products
    .filter((p) => p.category === selectedCategory)
    .slice(0, 3);

  // Optional: Calculate total, if you want a cart feature
  const total = filteredProducts.reduce(
    (sum, p) => sum + p.price * p.quantity,
    0
  );

  // Handle dropdown close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <>
      <div className="min-h-screen">
        <Header />
        <nav className="flex justify-center py-4 bg-gray-50">
          <ol className="flex items-center space-x-2">
            <li>
              <span className="text-gray-400 font-medium">Home</span>
            </li>
            <li>
              <span className="text-gray-300 font-medium">——</span>
            </li>
            <li>
              <span className="text-gray-700 font-medium">
                {selectedCategory}
              </span>
            </li>
          </ol>
        </nav>
        <div className="bg-white text-gray-800 max-w-7xl mx-auto px-4 py-12">
          <h1 className="text-3xl md:text-4xl text-center mb-6 secdory-font">
            {selectedCategory}
          </h1>

          <div className="flex flex-col lg:flex-row gap-8">
            {/* Sidebar */}
            <aside className="lg:w-1/4">
              <p className="text-gray-500 mb-2">
                We found{" "}
                <span className="font-bold">{filteredProducts.length}</span>{" "}
                products available for you
              </p>

              <div className="mb-6">
                <h2 className="font-semibold mb-3 secdory-font">Category</h2>
                <ul className="space-y-2 text-gray-600">
                  {categories.map((cat) => (
                    <li key={cat}>
                      <button
                        onClick={() => setSelectedCategory(cat)}
                        className={`hover:text-black ${
                          selectedCategory === cat ? "font-bold text-black" : ""
                        }`}
                      >
                        {cat}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h2 className="font-semibold mb-3 secdory-font">Highlight</h2>
                <ul className="space-y-2 text-gray-600">
                  <li>
                    <a href="#" className="hover:text-black">
                      Best Seller
                    </a>
                  </li>
                  <li>
                    <a href="#" className="hover:text-black">
                      New Arrivals
                    </a>
                  </li>
                  <li>
                    <a href="#" className="hover:text-black">
                      Sale
                    </a>
                  </li>
                  <li>
                    <a href="#" className="hover:text-black">
                      Hot Items
                    </a>
                  </li>
                </ul>
              </div>
            </aside>

            {/* Main Content */}
            <main className="lg:w-3/4">
              {/* Top Bar */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <button className="p-2 border rounded hover:bg-gray-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 6h4v4H4V6zM10 6h4v4h-4V6zM16 6h4v4h-4V6zM4 12h4v4H4v-4zM10 12h4v4h-4v-4zM16 12h4v4h-4v-4zM4 18h4v4H4v-4zM10 18h4v4h-4v-4zM16 18h4v4h-4v-4z"
                      />
                    </svg>
                  </button>
                  <button className="p-2 border rounded hover:bg-gray-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  </button>
                </div>

                {/* Dropdown example */}
                <div className="relative">
                  <button
                    ref={buttonRef}
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="flex items-center justify-between w-60 px-4 py-2 border rounded bg-white hover:bg-gray-50"
                  >
                    Sort by popularity
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 ml-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                  {dropdownOpen && (
                    <ul
                      ref={dropdownRef}
                      className="absolute right-0 mt-1 w-60 bg-white border rounded shadow-lg z-10"
                    >
                      <li>
                        <a
                          href="#"
                          className="block px-4 py-2 hover:bg-gray-100"
                        >
                          Default sorting
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          className="block px-4 py-2 hover:bg-gray-100"
                        >
                          Sort by popularity
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          className="block px-4 py-2 hover:bg-gray-100"
                        >
                          Sort by average rating
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          className="block px-4 py-2 hover:bg-gray-100"
                        >
                          Sort by latest
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          className="block px-4 py-2 hover:bg-gray-100"
                        >
                          Sort by price: low to high
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          className="block px-4 py-2 hover:bg-gray-100"
                        >
                          Sort by price: high to low
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </div>

              {/* Product Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {filteredProducts.length === 0 && (
                  <div className="col-span-full text-center text-gray-500">
                    No products in this category.
                  </div>
                )}
                {filteredProducts.map((product, idx) => (
                  <div
                    key={idx}
                    className="group relative custom-bg border border-gray-200 rounded-lg overflow-hidden p-4"
                  >
                    <span className="absolute top-3 left-3 bg-green-700 text-white text-sm font-bold px-2 py-0.5 rounded">
                      -
                      {100 -
                        Math.round((product.price / product.oldPrice) * 100)}
                      %
                    </span>
                    <div className="absolute top-3 right-3 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <button className="bg-white p-2 rounded-full shadow hover:bg-gray-100">
                        <Eye size={18} />
                      </button>
                      <button className="bg-white p-2 rounded-full shadow hover:bg-gray-100">
                        <Star size={18} />
                      </button>
                      <button className="bg-white p-2 rounded-full shadow hover:bg-gray-100">
                        <Repeat size={18} />
                      </button>
                    </div>
                    <div className="flex justify-center">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="h-60 object-contain"
                      />
                    </div>
                    <div className="absolute inset-x-0 bottom-10 flex justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <button className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800">
                        Add To Cart
                      </button>
                    </div>
                    <div className="mt-4 text-center">
                      <div className="text-gray-400 line-through text-sm">
                        ${product.oldPrice}.00
                      </div>
                      <div className="text-lg font-bold text-gray-900">
                        ${product.price}.00
                      </div>
                      <h3 className="text-gray-800 font-medium mt-1">
                        {product.name}
                      </h3>
                      {/* Demo: show fake reviews */}
                      <div className="flex items-center justify-center mt-1 text-sm text-gray-500">
                        <span className="flex text-green-600">★★★★☆</span>
                        <span className="ml-2">
                          {Math.floor(Math.random() * 1000 + 1500)} reviews
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </main>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Products;
